/**
 * The contact line under every Watch email and every public Watch page
 * (WatchReview, WatchPreferencesPage). One string so the email and the pages
 * never drift apart. It names no location rule: the old "supported location"
 * wording read as the reason a refused answer failed (PROD 2026-11-01).
 */
export const WATCH_CONTACT_LINE = 'Questions about this notice? Contact your onGuard administrator.';
